import React from 'react';
import { withRouter } from 'react-router-dom';
import  { Button } from '@royalnavy/react-component-library';

const ResultsBack = ({ history }) => <p><Button variant="primary" onClick={() => history.goBack()}>Return to search results</Button></p>;

export default withRouter(ResultsBack);

